import { useQuery } from 'react-query';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';

export default function useGetParams() {
  const { security: securityApi } = useApiContext();

  return useQuery(
    [KEYS.security.public.getParams(), 'WEB'],
    () =>
      securityApi.public.GetParams({
        platformSpec: 'WEB'
      }),
    {
      select: (data) => data,
      refetchOnWindowFocus: false
    }
  );
}
